var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompareTable',{attrs:{"rows":_vm.generatedRows}})
}
var staticRenderFns = []

export { render, staticRenderFns }